export function getVariantText(appearance, horizontalOrientation, verticalOrientation) {
    const sequence = horizontalOrientation === 'Image left' ? '3' : '1';
    const cols = appearance
        ? horizontalOrientation === 'Image left'
            ? appearance.charAt(appearance.length - 1)
            : appearance.charAt(0)
        : '';
    const defaultOrder = !appearance && verticalOrientation === 'Image bottom' ? '1' : '3';
    return appearance
        ? { span: cols, order: sequence, align: 'left' }
        : { span: '8', order: defaultOrder, align: 'center', offset: '2' };
}
export function getVariantMedia(appearance, horizontalOrientation, verticalOrientation) {
    const sequence = horizontalOrientation === 'Image left' ? '1' : '3';
    const cols = appearance
        ? horizontalOrientation === 'Image left'
            ? appearance.charAt(0)
            : appearance.charAt(appearance.length - 1)
        : '';
    const alignment = horizontalOrientation === 'Image left' ? 'left' : 'right';
    const defaultOrder = !appearance && verticalOrientation === 'Image bottom' ? '3' : '1';
    return appearance
        ? { span: cols, order: sequence, align: alignment }
        : { span: '8', order: defaultOrder, align: 'center', offset: '2' };
}
//Appearances:
// '7/5'
// '5/7'
// '6/1/5'
// '5/1/6'
// '8/4'
// '4/8'
// '7/1/4'
// '4/1/7'
// '6/6'
//# sourceMappingURL=variants.js.map